const subConfig =
  REACT_APP_ENV === 'live'
    ? {
        appId: '85e80adc3795147182c681ce7e69cbb9',
        secretKey: 'debd7036cbd4a88c1dd0f5cb83c0e832',
        publicKey:
          '-----BEGIN PUBLIC KEY-----' +
          'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAssAOqkyTje' +
          'H2A5OJBQducDPKC/J06hSraWQDvVtlVCPAqa8Jqnsv1x5Kb4i69WM7' +
          'GAis/EsjPYKEyxy6JEcCiZPqDpK2Poi8CwOvknD+reSQ9aCbqWkGPi' +
          'eRc8mYq8LgTzZtp0B2iiv4IcYHCWLdj/5lUIMmLe7fdMP9wo5+W3Xl' +
          'pBAcHyH+VJ3xzq/AaSR1JM4XEvQSLoMSnI2SW9Tusl3feUEB/iJVpu' +
          'oZ7lm9zWwcHmrHhCCuXuxdAoz6tG4jFBa2qK/OaI/EYzftBBsjdaH0' +
          'Od3IZUHfSJ2GHhzo1CEXONs8PpM1m47yaNVHhhMS/TZRR1url4/pR0' +
          'DwA7xFAwIDAQAB' +
          '-----END PUBLIC KEY-----',
      }
    : {
        appId: 'abf227432f9935a0a0dad51c5338a825',
        secretKey: '36f752f5c3733f83e3b0484c340bfd90',
        publicKey:
          '-----BEGIN PUBLIC KEY-----' +
          'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArnOzprxuryHHITI9oAL4' +
          '7FERvLyX5wPbE5Qy0q4vwnlj53zvAWXFfJ56/HJ9uoUMMu3Nz20SKt2vkXZ+1bcT' +
          'u3gUVnLZt+8c1Qmt2x5UFSj+Ip9Muc0CFr16ZYx9FMitabZO3dbe0qUH1+1x04Pf' +
          'pHDw2yCF4KpLTDfMmPBbmbs85RG1X6a0TrTpaFmvM+kl8Xr/yf3pamnGEaDNIBnL' +
          'WfR1er308DBXETOef3enx2/derbLJiQsWNQ3xWZZmhcUzRA6CuES/yZPndsmSIJp' +
          'CSxqPKqhibfVFacHYfXJ2PzDzVXM9SBp5lLZLkRI5L0rLq8CPQ8lULFDnvV0KmF9' +
          'WQIDAQAB' +
          '-----END PUBLIC KEY-----',
      };

const userSecConfig =
  REACT_APP_ENV === 'live'
    ? {
        appId: 'c3b91a3f32dcb07988b9f07406a7e453',
        secretKey: '571cf4b489675d0c4c2bfc473c6045de',
        publicKey:
          '-----BEGIN PUBLIC KEY-----' +
          'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAz68g17/3Tfije1ylLK0wD9GvR2kd/LVdHY7Cr3iC5xucvzQ2PgKuZyXiZgMWXcxtyRhyFILtX7cCQUg+pIXPU5w6g/EhaD555fEdqKWLFq8YkU62debDrKlyg6Qo687CfSdC58NL7IGRof6g++j+zFZzNW9idVIWo9I1exYMH4WZoz4iFqQUn8Z+IvOeHDheinN2QyBfcES0hjWBkLBD3WXSzrj2gncbxB2RLJHF4W2zpRYi195B8XMXmhhzSSlV1A5h6Vb4WbQkVPp5F0INP/CixDTXc7z18rwx54R4R7IosSpiGuGe8Ou9SFgiBR003JEFI7n7a7XuzrKndXd9iQIDAQAB' +
          '-----END PUBLIC KEY-----',
      }
    : {
        appId: '0cc11bf6d54b1f5f0344131cc4831761',
        secretKey: '5d7d1eb597c32fe6e3f9b7b8f133eac7',
        publicKey:
          '-----BEGIN PUBLIC KEY-----' +
          'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA9tCqAjzKAB2I+Vok7H/7AZDRW39MafhEsk2SldqfyUP7sFLnAzp/h5Z7ga+U/z04x8Y5y4dKtyMgVaeiAoHrGlR1Qt1NBgYn1DPyaRxypFKgZxSjHya/2PsUDHgkagZoHueaUg8a9E644DgUY7k+6vh6AiOEPOhcZF7WsCYbw+QIy/+a+aHe/Yp3/5t4MFDhe3tEIYyHX/5yHytuf3/pWimVrBetGZmtV5TnhVtnZljHfek1O/m6TQD4BDSi7rC0TCUfa8BbveQcTGvU6TsW+CHBzenNN3wqEL/4x4Wpux8Csd2dELoIgDRP7gNlpPBrk2TuIbSc6zVliSUM/vJbiQIDAQAB' +
          '-----END PUBLIC KEY-----',
      };

const envConfig = (() => {
  // mock, dev, test1, reg
  if (['mock', 'reg'].indexOf(REACT_APP_ENV) >= 0) {
    let env = 'reg';
    switch (REACT_APP_ENV) {
      case 'reg':
        env = 'reg';
        break;
      case 'mock':
      default:
        env = 'env3';
        break;
    }
    // const env = REACT_APP_ENV === 'test1' ? 'env1' : 'env3';
    return {
      iconPreUrl: `https://fastescrow-h5-${env}.test.scrediario.com.br`,
    };
  }
  if (REACT_APP_ENV === 'test1' || REACT_APP_ENV === 'staging') {
    // staging
    return {
      iconPreUrl: `https://fastescrow-h5.staging.scrediario.com.br`,
    };
  }

  // live
  if (REACT_APP_ENV === 'live') {
    return {
      iconPreUrl: `https://cdn.scredit.sg/${BIZ_COUNTRY}/fastescrow-h5/live`,
    };
  }
  // stable
  if (REACT_APP_ENV === 'stable' || REACT_APP_ENV === 'dev') {
    return {
      iconPreUrl: `https://fastescrow-h5.test-stable.scrediario.com.br`,
    };
  }
  // test, uat
  return {
    iconPreUrl: `https://fastescrow-h5.${REACT_APP_ENV}.scrediario.com.br`,
  };
})();

const dependDomain = (() => {
  switch (REACT_APP_ENV) {
    case 'mock':
    case 'dev':
      return {
        ucDomain: 'https://uc-h5-env3.test.scrediario.com.br',
        financeDomain: 'https://finance-env3.test.scrediario.com.br',
      };
    case 'stable':
      return {
        ucDomain: 'https://uc-h5.test-stable.scrediario.com.br',
        financeDomain: 'https://finance.test-stable.scrediario.com.br',
      };
    case 'test':
      return {
        ucDomain: 'https://uc-h5.test.scrediario.com.br',
        financeDomain: 'https://finance.test.scrediario.com.br',
      };
    case 'test1':
    case 'staging':
      return {
        ucDomain: 'https://uc-h5.staging.scrediario.com.br',
        financeDomain: 'https://finance.staging.scrediario.com.br',
      };
    case 'reg':
      return {
        ucDomain: 'https://uc-h5-reg.test.scrediario.com.br',
        financeDomain: 'https://finance-reg.test.scrediario.com.br',
      };
    case 'uat':
      return {
        ucDomain: 'https://uc-h5.uat.scrediario.com.br',
        financeDomain: 'https://finance.uat.scrediario.com.br',
      };
    case 'live':
    default:
      return {
        ucDomain: 'https://uc-h5.scrediario.com.br',
        financeDomain: 'https://finance.scrediario.com.br',
      };
  }
})();

const config = {
  platForm: 1,
  version: 1,
  region: 'br',
  fastEscrowVersion: 'fastescrow_v1.0.0.100',
  userSecConfig,
  ...subConfig,
  ...envConfig,
  ...dependDomain,
};

export default config;
